module.exports = __webpack_public_path__ + "img/00032.667e9b25.webp";